export default "__VITE_ASSET__BZA7noYN__"